import {APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {AuthService} from './auth.service';
import {LoginGuard} from './login-guard.service';
import {AuthGuard} from './auth-guard.service';
import {AppConfigLoader} from './shared/app-config.loader';
import {Store} from '@ngrx/store';

const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', loadChildren: 'app/login/login.module#LoginModule', canActivate: [LoginGuard]},
  {path: '', loadChildren: 'app/dashboard/index.module#DashboardModule', canActivate: [AuthGuard]},
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, initialNavigation: 'enabled'})],
  providers: [AuthService, LoginGuard, AuthGuard, {
    provide: APP_INITIALIZER,
    useFactory: AppConfigLoader,
    multi: true,
    deps: [Store, AuthService]
  }],
  exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/app-routing.module.ts